export default __webpack_public_path__ + "static/media/step3.1eced8e4.svg";